import $ from 'jquery';

export const fetchProductFiltersList = async (scope, key, category) => {
  const result = await $.post({
    url: '/wp-admin/admin-ajax.php?action=eq2-product-filters',

    data: { scope, category },
  });

  return {
    filters: result.data.filters || [],
  };
};

export const fetchCategoriesList = async (scope, key) => {
  const result = await $.post({
    url: '/wp-admin/admin-ajax.php?action=eq2-categories',
    data: { scope },
  });

  return {
    root_id: result.data.root_id,
    items: result.data.data,
  };
};

export const fetchItemsList = async (scope, key, category, filters, currentPage, order) => {
  const result = await $.post({
    url: '/wp-admin/admin-ajax.php?action=eq2-products',
    data: {
      scope,
      category,
      filters: filters,
      page: currentPage || 1,
      order,
    },
  });

  return result.data;
};

export const fetchTaxList = async (scope, key, taxonomy, category, filters) => {
  const result = await $.post({
    url: '/wp-admin/admin-ajax.php?action=eq2-terms',
    data: {
      scope,
      taxonomy,
      category,
      filters,
    },
  });

  return result.data;
};

export const fetchFilterMinMax = async (scope, key, taxonomy, category, filters) => {
  const result = await $.post({
    url: '/wp-admin/admin-ajax.php?action=eq2-filter_min_max',
    data: {
      scope,
      taxonomy,
      category,
      filters,
    },
  });

  return result.data;
};
